import {course_getCourseClassById_Api,} from 'apis'
import {TabNavigation} from '../../../Shared/components/TabNavigation'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import React, {useContext, useEffect, useState,} from 'react'
import {useRouteSearchParam} from "../../../../envs/_current/history";
import {CourseContainerContext} from "./CourseContainer";
import {BsArrowLeftCircle, BsCalendar2Week, BsGearFill} from "react-icons/bs";
import _ from "lodash"
import useTranslate from "../../../../modules/local/useTranslate";
import {PiChecks, PiGraduationCap} from "react-icons/pi";
import {bindingSearch} from "../../../Shared/components/PagerControls";
import {useCourseClassForm} from "../../../AppLocals/Course/CourseClass/useCourseClassForm";
import {CourseClassStudentList} from "../../../AppLocals/Course/CourseClass/CourseClassStudentForm";
import CourseClassTeachers from "../../../AppLocals/Course/CourseClass/CourseClassTeachers";
import {EditCourseClassModal} from "../../../AppLocals/Course/CourseClass/CourseClassForm";
import {NullAsDefault} from "../../../Shared";
import {useCourseClassApi} from "../../../AppLocals/Course/CourseClass/useCourseClassApi";
import {ClassActionTypes} from "../../../AppLocals/Course";
import {useRouterSearchParam} from "../../../../modules/navigation/useOnLocationChange";
import {FaUserGraduate, FaUserTie} from "react-icons/fa6";
import {CourseClassAttendancePanel} from "./CourseClassList/CourseClassAttendancePanel";
import {CourseClassGradingPanel} from "./CourseClassList/CourseClassGradingPanel";
import {CourseClassTimetablePanel} from "./CourseClassList/CourseClassTimetablePanel";
import useScrollHide from "../../../../hooks/useScrollHide";
import classNames from "classnames";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {ClassInfoBanner} from "../components/ClassInfoBanner";

const CLASS_TABS = [
    {key: 'schedule',   name: 'timetable',   icon: <BsCalendar2Week size={18}/>},
    // Tab "Môn học" riêng đã BỎ - chuyển thành chip-select (CourseClassSubjectChips) nằm NGAY
    // TRONG form ở tab "Cấu hình Lớp học" (case 'settings' bên dưới dùng EditCourseClassModal,
    // xem Section "class subjects" trong CourseClassForm.js) để gọn menu, cùng 1 chỗ với các cấu
    // hình khác của lớp thay vì tách tab riêng.
    {key: 'teacher',    name: 'teacher',      icon: <FaUserTie size={15}/>},
    {key: 'student',    name: 'student',      icon: <FaUserGraduate size={15}/>},
    {key: 'attendance', name: 'attendance',   icon: <PiChecks size={16}/>},
    {key: 'grading',    name: 'gradebook',    icon: <PiGraduationCap size={16}/>},
    {key: 'settings',   name: 'class settings', icon: <BsGearFill size={16}/>},
];


// hideHeader: cho phép nhúng riêng khối tab+nội dung vào màn khác đã tự vẽ header (vd
// CourseClassOperations.js - "Điều hành Khóa & Lớp học", header ở đó KHÔNG có nút "quay lại khóa"
// vì trang đó hiển thị nối tiếp khóa+lớp trên cùng 1 màn, không phải luồng back/forward). Trang
// dùng CourseClassDetail qua CourseContainer.js (drill-down khóa->lớp thông thường) không truyền
// prop này, giữ nguyên header+back cũ.
const CourseClassDetail = ({hideHeader = false}) => {
    const t = useTranslate();
    const {isLg} = useContext(LayoutContext)
    const courseClassDetailTab = useRouteSearchParam("course-class-detail-tab") || "schedule"
    const [activeTab, setActiveTab] = useState(courseClassDetailTab);
    const [selectedCourseClass, setSelectedCourseClass] = useState({});
    const {
        current_course_id, setCurrentCourseId,
        current_course_class_id, setCurrentCourseClassId,
        onSelectCourseContainerRoute
    } = useContext(CourseContainerContext);

    const {handleAsyncAction: getCourseClassById} = useAsyncAction({
        apiInfo: course_getCourseClassById_Api,
        onSuccess: (result, data) => {
            const dataItem = _.get(data, 'response.data');
            setSelectedCourseClass(dataItem);
        },
    })
    const {onChangeSearchParams} = useRouterSearchParam({})

    const course = _.get(selectedCourseClass, 'course', {});
    const {
        modal: courseClassModal,
        handleAction: handleCourseClassAction,
        onCancel: onCourseClassCancel,
    } = useCourseClassForm({course})
    const {
        onUpdate: onCourseClassUpdate
    } = useCourseClassApi({
        onUpdated: NullAsDefault,
    })

    useEffect(() => {
        if (current_course_class_id) {
            getCourseClassById({}, {id: current_course_class_id})
        }
    }, [current_course_class_id])

    const renderCourseClassContent = () => {
        switch (activeTab) {
            case 'schedule':
                return <CourseClassTimetablePanel item={selectedCourseClass}/>
            case 'student':
                return (
                    <div className="flex flex-col">
                        {!!selectedCourseClass?.id && bindingSearch({
                            onCancel: onCourseClassCancel,
                            owner_id: selectedCourseClass?.owner?.id,
                            owner_type: selectedCourseClass?.owner?._type,
                            item: selectedCourseClass,
                            onCourseClassChange: setSelectedCourseClass,
                        })(CourseClassStudentList)}
                    </div>
                );
            case 'teacher':
                return (
                    <div className="flex flex-col">
                        {!!selectedCourseClass?.id && bindingSearch({
                            onCancel: onCourseClassCancel,
                            owner_id: selectedCourseClass?.owner?.id,
                            owner_type: selectedCourseClass?.owner?._type,
                            item: selectedCourseClass,
                        })(CourseClassTeachers)}
                    </div>
                );
            case 'attendance':
                return <CourseClassAttendancePanel item={selectedCourseClass}/>
            case 'grading':
                return <CourseClassGradingPanel item={selectedCourseClass}/>
            case 'settings':
                return (
                    <div className="flex flex-col">
                        <div className="mb-4 flex flex-col flex-1">
                            <h3 className="font-bold text-base text-slate-600 tracking-wide">
                                {t('class settings')}
                            </h3>
                            <div style={{ height: 3 }} className="my-1 w-20 h-1 rounded-full bg-gray-400"/>
                            <div className="text-color-300 tracking-wider">
                                {t('manage name description start end dates')}
                            </div>
                        </div>
                        {/*<div className="my-3 flex flex-col gap-1">*/}
                        {/*    <label className="text-sm font-medium text-color-200 tracking-wider">*/}
                        {/*        {t('belong to the course')}*/}
                        {/*    </label>*/}
                        {/*    <div className="p-3 flex flex-col border border-color-50 shadow rounded-lg">*/}
                        {/*        <div className="mb-2 pb-2 border-b border-color-100 flex items-center gap-2">*/}
                        {/*            <Link to={getLinkToDetail(course)} className="font-bold text-base text-color-000 tracking-wide">*/}
                        {/*                {getTitle(course)}*/}
                        {/*            </Link>*/}
                        {/*        </div>*/}
                        {/*        <div className="flex flex-col flex-1 gap-1">*/}
                        {/*            {(course?.academic_field !== null || course?.academic_year !== 0) && (*/}
                        {/*                <div*/}
                        {/*                    style={{ padding: '3px 8px', fontSize: 11, borderRadius: 999, wordBreak: 'break-all' }}*/}
                        {/*                    className="w-fit border border-primary-400 font-medium text-primary-700 italic leading-tight min-w-0 max-lines-1">*/}
                        {/*                    {course?.academic_field}*/}
                        {/*                    {(course?.academic_year !== 0 && course?.academic_field !== null) ? ` - ${course?.academic_year}` : course?.academic_year !== 0 ? course?.academic_year : ''}*/}
                        {/*                </div>*/}
                        {/*            )}*/}
                        {/*            {_.some([course?.time_open, course?.time_close]) && (*/}
                        {/*                <DoubleValueItem*/}
                        {/*                    showIcon={true}*/}
                        {/*                    labelFirst="time"*/}
                        {/*                    valueFirst={formatSimplifyDate(course?.time_open, 'medium')}*/}
                        {/*                    labelSecond={course?.time_close && ' - ' || ''}*/}
                        {/*                    valueSecond={course?.time_close && formatSimplifyDate(course?.time_close, 'medium')}*/}
                        {/*                    className="text-xs italic"*/}
                        {/*                />*/}
                        {/*            )}*/}
                        {/*            {course?.last_enrollment_time && (*/}
                        {/*                <ItemInformation*/}
                        {/*                    showIcon={true}*/}
                        {/*                    label="last enrollment time"*/}
                        {/*                    value={formatSimplifyDate(course?.last_enrollment_time, 'medium')}*/}
                        {/*                    className="text-xs italic tracking-wide"*/}
                        {/*                />*/}
                        {/*            )}*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        {!!selectedCourseClass?.id && (
                            <EditCourseClassModal
                                item={selectedCourseClass}
                                owner_id={course?.owner?.id}
                                owner_type={course?.owner?._type}
                                container={course}
                                initialValues={selectedCourseClass}
                                onCancel={onCourseClassCancel}
                                onSubmit={(values) => {
                                    onCourseClassUpdate(values, {id: selectedCourseClass?.id})
                                }}
                            />
                        )}

                        {/* "Xóa lớp học" - TRƯỚC ĐÂY là 1 tab riêng ("Xóa nội dung", key='destroy') -
                            gộp xuống cuối tab "Cấu hình Lớp học" để gọn menu, bỏ hẳn tab riêng. Vẫn
                            giữ NGUYÊN hành động (handleCourseClassAction CLASS_DELETE) - chỉ đổi vị
                            trí. Đóng khung riêng hẳn 1 card viền/nền đỏ (KHÔNG chỉ 1 đường kẻ phân
                            cách như trước) để tách bạch khỏi phần cấu hình thường phía trên - CHỈ
                            dùng màu đỏ làm tín hiệu cảnh giác (bạn yêu cầu bỏ hẳn tag/nhãn "Vùng nguy
                            hiểm", không thêm badge/icon rườm rà). */}
                        <div className="mt-8 p-4 rounded-xl border-2 border-red-200 bg-red-50 flex flex-col">
                            <div className="mb-3 flex flex-col flex-1">
                                <h3 className="font-bold text-base text-red-700 tracking-wide">
                                    {t('delete class')}
                                </h3>
                                <div className="text-red-500 tracking-wider">
                                    {t('this action will permanently delete the class and all related data please confirm before proceeding')}
                                </div>
                            </div>
                            <div className="flex justify-end">
                                <button
                                    onClick={() => {
                                        handleCourseClassAction(ClassActionTypes.CLASS_DELETE, selectedCourseClass)
                                    }}
                                    className="px-6 py-2 bg-red-600 hover:bg-red-700 shadow-md rounded-lg font-medium text-white"
                                >
                                    {t("delete class permanently")}
                                </button>
                            </div>
                        </div>
                    </div>
                );
            default:
                return null;
        }
    };

    const {hidden} = useScrollHide()

    return (
        <div className="w-full min-h-screen">
            {!hideHeader && (
                <div className="mb-6">
                    {/* Nút back ĐƯA RA NGOÀI banner màu (trước đây nằm lồng trong banner trắng cũ,
                        bạn góp ý tách hẳn ra làm breadcrumb điều hướng - không phải nội dung của
                        banner) - không phải nội dung "chi tiết lớp" nên KHÔNG đưa vào ClassInfoBanner
                        dùng chung. Banner bên dưới tách sang ClassInfoBanner.js (dùng CHUNG với
                        CourseClassPanelDetail.js - popup "Chi tiết lớp học" mở từ danh sách lớp, trước
                        đây tự vẽ khối trắng riêng thiếu hẳn danh sách môn học, bạn báo lệch UI). */}
                    <button
                        onClick={() => {
                            onSelectCourseContainerRoute({current_course_class_id: ''})
                        }}
                        className="mb-2 flex items-center text-color-300 hover:text-color-100 tracking-wide cursor-pointer">
                        <BsArrowLeftCircle size={18} className="mr-2"/>
                        {`${t("back to course")} :`}
                        <span className="ml-1 font-medium text-primary-800 italic">
                            {course.title}
                        </span>
                    </button>
                    <ClassInfoBanner item={selectedCourseClass}/>
                </div>
            )}
            <TabNavigation
                tabs={CLASS_TABS}
                activeTab={activeTab}
                style={{
                    marginLeft: !isLg && '-0.75rem',
                    marginRight: !isLg && '-0.75rem',
                }}
                className={classNames("border-color-300 transition-all duration-300 ", isLg ? 'stickyTop1' : hidden ? 'stickyTop' : 'stickyTop1')}
                onTabChange={(value) => {
                    onChangeSearchParams({"course-class-detail-tab": value})
                    setActiveTab(value)
                }}
            />

            <div className="p-3 md:p-6 background rounded-b-2xl shadow-lg">
                {renderCourseClassContent()}
            </div>

            {courseClassModal}

            <div className="h-20"/>
        </div>
    );
};


export default CourseClassDetail
